/* eslint-disable no-unused-vars */
<template>
  <div>
    <div style="text-align: left;"><img src="../assets/logo.jpg" alt="" srcset=""></div>
    <a-upload
      :accept="acceptFile"
      :file-list="fileList"
      :remove="handleRemove"
      :before-upload="beforeUpload"
      ref="uploadWidget"
      style="margin-bottom: 20px"
    >
      <a-button type="primary" style="margin-bottom: 10px"> <a-icon type="upload" />选择文件</a-button>
    </a-upload>
    <h2>csv导入生成图表功能</h2>
    <!-- <a-button @click="generatePDF">toPDF</a-button> -->
    <div>
      <v-chart :options="batteryVoltageOptions" autoresize="true" />
    </div>

    <div>
      <v-chart :options="dischargeCurrentOptions" autoresize="true" />
    </div>
    <div>
      <v-chart :options="dischargedCapacityOptions" autoresize="true" />
    </div>
    <!-- <div>
      <v-chart :options="batteryVoltageArrayOptions" autoresize="true" />
    </div> -->
  </div>
</template>
<script>
//import XLSX from 'xlsx';
/* eslint-disable no-unused-vars */
const batteryVoltageOptions = {
  title: {
    text: '电池电压',
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#283b56',
      },
    },
  },
  toolbox: {
    show: true,
    feature: {
      dataZoom: {
        yAxisIndex: 'none',
      },
      dataView: {readOnly: false},
      magicType: {type: ['line', 'bar']},
      restore: {},
      saveAsImage: {},
    },
  },
  legend: {
    data: ['电池电压'],
  },
  dataZoom: {
    show: false,
    start: 0,
    end: 100,
  },
  xAxis: [
    {
      type: 'category',
      boundaryGap: true,
      data: [],
    },
  ],
  yAxis: [
    {
      type: 'value',
      scale: true,
      name: '电压（V）',
      // max: 240,
      // min: 200,
      boundaryGap: [0.2, 0.2],
    },
  ],
  series: [
    {
      name: '电池电压',
      type: 'line',
      data: [],
    },
  ],
};
const dischargeCurrentOptions = {
  title: {
    text: '放电电流',
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#283b56',
      },
    },
  },
  toolbox: {
    show: true,
    feature: {
      dataZoom: {
        yAxisIndex: 'none',
      },
      dataView: {readOnly: false},
      magicType: {type: ['line', 'bar']},
      restore: {},
      saveAsImage: {},
    },
  },
  legend: {
    data: ['放电电流'],
  },
  dataZoom: {
    show: false,
    start: 0,
    end: 100,
  },
  xAxis: [
    {
      type: 'category',
      boundaryGap: true,
      data: [],
    },
  ],
  yAxis: [
    {
      type: 'value',
      scale: true,
      name: '电流（A）',
      // max: 15,
      // min: 0,
      boundaryGap: [0.2, 0.2],
    },
  ],
  series: [
    {
      name: '放电电流',
      type: 'line',
      data: [],
    },
  ],
};
const dischargedCapacityOptions = {
  title: {
    text: '已放电容量',
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#283b56',
      },
    },
  },
  toolbox: {
    show: true,
    feature: {
      dataZoom: {
        yAxisIndex: 'none',
      },
      dataView: {readOnly: false},
      magicType: {type: ['line', 'bar']},
      restore: {},
      saveAsImage: {},
    },
  },
  legend: {
    data: ['已放电容量'],
  },
  dataZoom: {
    show: false,
    start: 0,
    end: 100,
  },
  xAxis: [
    {
      type: 'category',
      boundaryGap: true,
      data: [],
    },
  ],
  yAxis: [
    {
      type: 'value',
      scale: true,
      name: '电容量（kwh）',
      // max: 2,
      // min: 0,
      boundaryGap: [0.2, 0.2],
    },
  ],
  series: [
    {
      name: '已放电容量',
      type: 'line',
      data: [],
    },
  ],
};
const batteryVoltageArrayOptions = {
  title: {
    text: '单个电池电压',
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#283b56',
      },
    },
  },
  toolbox: {
    show: true,
    feature: {
      dataZoom: {
        yAxisIndex: 'none',
      },
      dataView: {readOnly: false},
      magicType: {type: ['line', 'bar']},
      restore: {},
      saveAsImage: {},
    },
  },
  legend: {
    data: [],
  },
  dataZoom: {
    show: false,
    start: 0,
    end: 100,
  },
  xAxis: [
    {
      type: 'category',
      boundaryGap: true,
      data: [],
    },
  ],
  yAxis: [
    {
      type: 'value',
      scale: true,
      name: '电压（V）',
      // max: 15,
      // min: 7,
      boundaryGap: [0.2, 0.2],
    },
  ],
  series: [],
};
export default {
  data: () => {
    return {
      file: null,
      acceptFile: 'xlxs,xls',
      fileList: [],
      batteryVoltageOptions: batteryVoltageOptions,
      dischargeCurrentOptions: dischargeCurrentOptions,
      dischargedCapacityOptions: dischargedCapacityOptions,
      batteryVoltageArrayOptions: batteryVoltageArrayOptions,
    };
  },
  mounted() {},
  methods: {
    handleRemove() {
      this.file = null;
    },
    beforeUpload(file) {
      let $this = this;
      this.file = file;
      let f = file;
      var reader = new FileReader();
      reader.onload = function(e) {
        const csvData = e.target.result.split('\n');
        let variables = [];
        csvData.map((v) => {
          if (v) {
            variables.push(v.split(','));
          }
        });
        let timeData = $this.getColDate(variables, 1);
        let batteryVoltage = $this.getColDate(variables, 2);
        let dischargeCurrent = $this.getColDate(variables, 3);
        let dischargedCapacity = $this.getColDate(variables, 4);
        let batteryVoltageArray = [];
        for (let index = 5; index < variables[0].length; index++) {
          batteryVoltageArray.push($this.getColDate(variables, index));
        }

        $this.batteryVoltageOptions.xAxis[0].data = timeData.slice(1);
        $this.batteryVoltageOptions.series[0].data = batteryVoltage.slice(1);
        $this.dischargeCurrentOptions.xAxis[0].data = timeData.slice(1);
        $this.dischargeCurrentOptions.series[0].data = dischargeCurrent.slice(1);
        $this.dischargedCapacityOptions.xAxis[0].data = timeData.slice(1);
        $this.dischargedCapacityOptions.series[0].data = dischargedCapacity.slice(1);
        $this.batteryVoltageArrayOptions.xAxis[0].data = timeData.slice(1);
        $this.batteryVoltageArrayOptions.series = batteryVoltageArray.map((item) => {
          return {
            data: item.slice(1),
            name: item[0],
            type: 'line',
          };
        });
        $this.batteryVoltageArrayOptions.legend.data = batteryVoltageArray.map((item) => item[0]);
      };
      reader.readAsText(f);
      return false;
    },
    removeFile() {
      this.$refs.uploadWidget.fileList = [];
    },
    getColDate(data, num) {
      let r = data.map((item) => {
        return item[num].replace(/\r/g, '');
      });
      return r;
    },
    // generatePDF() {
    //   const doc = new jsPDF();

    //   doc.text('Hello world!', 10, 100);
    //   doc.save('a4.pdf');
    // },
  },
};
</script>

<style>
#app .echarts {
  width: 100%;
  height: 400px;
}
</style>
